module.exports = new __parcel__URL__("python.a983c004.png").toString();